import React, { lazy } from 'react'
import clsx from 'clsx'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { FieldColumnName } from '../fields/FieldColumnName'
import { FieldColumnType } from '../fields/FieldColumnType'

const FieldAddress = lazy(() => import('../fields/FieldAddress'))
const FieldDateTime = lazy(() => import('../fields/FieldDateTime'))
const FieldNumber = lazy(() => import('../fields/FieldNumber'))
const FieldImage = lazy(() => import('../fields/FieldImage'))
const FieldRating = lazy(() => import('../fields/FieldRating'))
const FieldQRCode = lazy(() => import('../fields/FieldQRCode'))
const FieldBarcode = lazy(() => import('../fields/FieldBarcode'))
const FieldColor = lazy(() => import('../fields/FieldColor'))
const FieldConnection = lazy(() => import('../fields/FieldConnection'))
const FieldLookup = lazy(() => import('../fields/FieldLookup'))
const FieldJoin = lazy(() => import('../fields/FieldJoin'))
const FieldFunction = lazy(() => import('../fields/FieldFunction'))
const FieldFormula = lazy(() => import('../fields/FieldFormula'))
const FieldMath = lazy(() => import('../fields/FieldMath'))
const FieldTemplate = lazy(() => import('../fields/FieldTemplate'))
const FieldSingleCell = lazy(() => import('../fields/FieldSingleCell'))
const FieldSeoAI = lazy(() => import('../fields/FieldSeoAI'))
const FieldTextAI = lazy(() => import('../fields/FieldTextAI'))
const FieldSlug = lazy(() => import('../fields/FieldSlug'))

const LoadingSkeleton = () => (
  <div className='mt-4 space-y-2'>
    <div className='animate-pulse bg-zinc-300 dark:bg-slate-700 w-full h-6 rounded-sm' />
    <div className='animate-pulse bg-zinc-300 dark:bg-slate-700 w-full h-6 rounded-sm' />
    <div className='animate-pulse bg-zinc-300 dark:bg-slate-700 w-full h-6 rounded-sm' />
    <div className='animate-pulse bg-zinc-300 dark:bg-slate-700 w-full h-6 rounded-sm' />
  </div>
)

interface ColumnSettingFieldsProps {
  type: ColumnTypes
  isEdit: boolean
  isCustomSize: boolean
  portalType?: boolean
  wrapClassName?: string
}

export const ColumnSettingFields = ({
  type,
  isCustomSize,
  isEdit,
  portalType,
  wrapClassName,
}: ColumnSettingFieldsProps) => {
  return (
    <div className={clsx('max-h-[65vh] overflow-y-auto mk-scroll', 'w-full py-2 px-4', wrapClassName)}>
      <FieldColumnName />
      <FieldColumnType portal={portalType} isEdit={isEdit} isCustomSize={isCustomSize} />

      <React.Suspense fallback={<LoadingSkeleton />}>
        {type === ColumnTypes.DateTime && <FieldDateTime />}
        {type === ColumnTypes.Number && <FieldNumber />}
        {type === ColumnTypes.Address && <FieldAddress />}
        {type === ColumnTypes.Image && <FieldImage />}
        {/* {type === ColumnTypes.Icon && <FieldIcon />} */}
        {type === ColumnTypes.Rating && <FieldRating />}
        {type === ColumnTypes.Slug && <FieldSlug />}
        {type === ColumnTypes.AISEO && <FieldSeoAI />}
        {type === ColumnTypes.AITextProcessing && <FieldTextAI />}
        {type === ColumnTypes.QRCode && <FieldQRCode />}
        {type === ColumnTypes.Barcode && <FieldBarcode />}
        {type === ColumnTypes.Color && <FieldColor />}
        {type === ColumnTypes.Connection && <FieldConnection />}
        {type === ColumnTypes.Lookup && <FieldLookup />}
        {type === ColumnTypes.Join && <FieldJoin />}
        {type === ColumnTypes.Function && <FieldFunction />}
        {type === ColumnTypes.Formula && <FieldFormula />}
        {type === ColumnTypes.Math && <FieldMath />}
        {type === ColumnTypes.Template && <FieldTemplate />}
        {type === ColumnTypes.SingleCell && <FieldSingleCell />}
      </React.Suspense>
    </div>
  )
}
